import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faSyncAlt,
    faChevronDown,
    faEdit,
    faCalendarDays,
    faUserClock,
    faEraser,
} from '@fortawesome/free-solid-svg-icons'
import Aside from '../../component/aside'
import Navbar from '../../component/navbar'
import Loading from '../../component/loading'
import { toast } from 'react-toastify'
import RequestQueue from '../../api/requestQueue'
import DatePicker, { DateObject } from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import Toolbar from 'react-multi-date-picker/plugins/toolbar'
import { FormJsonToShamsiDay } from '../../component/FormJsonToShamsiDay'
import Pagination from 'rc-pagination'
import { AppContextMenu } from '../../App'
import { FormJsonToShamsiTime } from '../../component/FormJsonToShamsiTime'

function FurloughGetManagment() {
    const { updateValue } = useContext(AppContextMenu)
    useEffect(() => {
        updateValue('furloughGetManagment')
    }, [])
    const [loading, setLoading] = useState(false)
    const [dataGet, setDataGet] = useState([])
    const [userDataGet, setUserDataGet] = useState([])
    const [filters, setFilters] = useState({
        user: 'none',
        status: 'none',
    })
    const [currentPage, setCurrentPage] = useState(1)
    const pageSize = 10
    const [total, setTotal] = useState(10)
    const onChange = (page) => {
        setCurrentPage(page)
        // اینجا می‌توانید داده‌های مربوط به صفحه جدید را بارگذاری کنید
    }

    const [selectedDateStart, setSelectedDateStart] = useState()
    const [selectedDateEnd, setSelectedDateEnd] = useState()
    const navigate = useNavigate()

    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
        getUsers()
    }, [])

    useEffect(() => {
        getData()
    }, [currentPage, filters, selectedDateStart, selectedDateEnd])

    const getData = async () => {
        setLoading(true)

        let url = `/furlough-request/filtered?page=${currentPage}&limit=${pageSize}`
        if (
                filters.user !== undefined &&
                filters.user !== '' &&
                filters.user !== 'none' &&
                filters.user !== null
            ) {
                url = url + `&userId=${filters.user}`
            }
            if (
                selectedDateStart !== undefined &&
                selectedDateStart !== '' &&
                selectedDateStart !== null
            ) {
                try {
                    // ایجاد آبجکت تاریخ شمسی
                    const persianDate = new DateObject({
                        calendar: persian,
                        locale: persian_fa,
                        date: selectedDateStart,
                    })

                    // تبدیل به تاریخ میلادی
                    const gregorianDate = persianDate.convert()

                    // گرفتن سال، ماه و روز از تاریخ میلادی
                    let year = gregorianDate.year
                    let month = gregorianDate.month.number
                    let day = gregorianDate.day

                    // برای شروع روز در زمان تهران (00:00:00)
                    // تبدیل به زمان UTC یعنی روز قبل ساعت 20:30:00
                    // کم کردن 3:30 ساعت از 00:00 می‌شود 20:30 روز قبل
                    let utcHour = 20
                    let utcMinute = 30

                    // تاریخ را یک روز کم می‌کنیم چون 00:00 تهران برابر با 20:30 روز قبل در UTC است
                    const prevDate = new DateObject({
                        date: `${year}-${month}-${day}`,
                        format: 'YYYY-MM-DD',
                    }).subtract(1, 'day')

                    year = prevDate.year
                    month = prevDate.month.number
                    day = prevDate.day

                    // ساخت مستقیم رشته ISO با زمان UTC معادل 00:00 تهران
                    const pad = (num) => num.toString().padStart(2, '0')
                    const isoString = `${year}-${pad(month)}-${pad(day)}T${pad(utcHour)}:${pad(utcMinute)}:00.000Z`

                    url = url + `&startDate=${isoString}`
                } catch (error) {
                    console.error('خطا در تبدیل تاریخ شروع:', error)
                }
            }
            if (
                selectedDateEnd !== undefined &&
                selectedDateEnd !== '' &&
                selectedDateEnd !== null
            ) {
                try {
                    // ایجاد آبجکت تاریخ شمسی
                    const persianDate = new DateObject({
                        calendar: persian,
                        locale: persian_fa,
                        date: selectedDateEnd,
                    })

                    // تبدیل به تاریخ میلادی
                    const gregorianDate = persianDate.convert()

                    // گرفتن سال، ماه و روز از تاریخ میلادی
                    let year = gregorianDate.year
                    let month = gregorianDate.month.number
                    let day = gregorianDate.day

                    // برای پایان روز در زمان تهران (23:59:59)
                    // تبدیل به زمان UTC یعنی همان روز ساعت 20:29:59
                    // کم کردن 3:30 ساعت از 23:59:59 می‌شود 20:29:59
                    let utcHour = 20
                    let utcMinute = 29
                    let utcSecond = 59

                    // ساخت مستقیم رشته ISO با زمان UTC معادل 23:59:59 تهران
                    const pad = (num) => num.toString().padStart(2, '0')
                    const isoString = `${year}-${pad(month)}-${pad(day)}T${pad(utcHour)}:${pad(utcMinute)}:${pad(utcSecond)}.999Z`

                    url = url + `&endDate=${isoString}`
                } catch (error) {
                    console.error('خطا در تبدیل تاریخ پایان:', error)
                }
            }
            if (
                filters.status !== undefined &&
                filters.status !== '' &&
                filters.status !== 'none' &&
                filters.status !== null
            ) {
                url = url + `&status=${filters.status}`
            }
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: url,
            },
            resolve: (res) => {
                setDataGet(res.data.data)
                setTotal(res.data.totalFurloughs)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const getUsers = async () => {
        await RequestQueue.sendRequest({
            config: {
                method: 'get',
                url: `/user?page=1&limit=1000000000000`,
            },
            resolve: (res) => {
                setUserDataGet(res.data.data)
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const handlerView = (id) => {
        navigate(`/furloughGetViewManagment/${id}`)
    }

    const handlerDelete = async (id) => {
        await RequestQueue.sendRequest({
            config: {
                method: 'delete',
                url: `/furlough-request/${id}`,
            },
            resolve: (res) => {
                getData()
                toast.dismiss()
                toast.warn('با موفقیت حذف شد', {
                    position: 'bottom-center',
                })
                setLoading(false)
            },
            reject: (error) => {
                setLoading(false)
                toast.dismiss()
                toast.error('خطا در ارتباط با سرور', {
                    position: 'bottom-center',
                })
            },
        })
    }

    const handleFilterChange = (e) => {
        const { name, value } = e.target
        setCurrentPage(1)
        setFilters((prev) => ({ ...prev, [name]: value }))
    }

    const handleDateStartChange = (date) => {
        setCurrentPage(1)
        setSelectedDateStart(date)
    }

    const handleDateEndChange = (date) => {
        setCurrentPage(1)
        setSelectedDateEnd(date)
    }

    const getStatusBadge = (status) => {
        switch (status) {
            case 'pending':
                return (
                    <span className="px-3 py-1 bg-yellow-100 text-yellow-800 rounded-full text-xs">
                        انتظار
                    </span>
                )
            case 'confirm':
                return (
                    <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-xs">
                        تایید
                    </span>
                )
            case 'reject':
                return (
                    <span className="px-3 py-1 bg-red-100 text-red-800 rounded-full text-xs">
                        رد
                    </span>
                )
            default:
                return (
                    <span className="px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-xs">
                        نامشخص
                    </span>
                )
        }
    }

    const renderPageItem = (current, type, originalElement) => {
        if (type === 'prev') {
            return (
                <button className="px-4 py-2 hover:text-indigo-800">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-4"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
                        />
                    </svg>
                </button>
            )
        }
        if (type === 'next') {
            return (
                <button className="px-4 py-2  hover:text-indigo-800">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-4"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
                        />
                    </svg>
                </button>
            )
        }
        if (type === 'page') {
            return (
                <button
                    className={`px-2.5 m-1 py-0.5  rounded-md ${current === currentPage ? 'bg-indigo-700 text-white' : 'bg-white border border-gray-300 '}`}
                >
                    {current}
                </button>
            )
        }
        if (type === 'jump-prev' || type === 'jump-next') {
            return (
                <button className="bg-white border border-gray-300 rounded-md px-2.5 m-1 py-0.5  ">
                    ...
                </button>
            )
        }
        return originalElement
    }

    return (
        <>
            {loading && <Loading />}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />
                    <div className="box transaction-box w-full">
                        <div className="w-full px-4 py-8">
                            <div className="bg-white w-full rounded-xl shadow-sm  border border-gray-100">
                                {/* Header - Fixed Desktop Style */}
                                <div className="px-6 py-5 border-b rounded-xl border-gray-200 flex maxLg:flex-col justify-between items-center bg-gradient-to-r from-purple-100 to-indigo-500  ">
                                    <h2 className="text-2xl font-semibold text-white">
                                        {RequestQueue.getAuthResult()?.user
                                            ?.role.name === 'employee'
                                            ? 'تاریخچه مرخصی دیگران'
                                            : 'تاریخچه همه مرخصی‌ها'}
                                    </h2>
                                    <div className="flex">
                                        <button
                                            onClick={() => {
                                                setCurrentPage(1)
                                                setFilters({
                                                    user: 'none',
                                                    status: 'none',
                                                })
                                                setSelectedDateEnd(null)
                                                setSelectedDateStart(null)
                                            }}
                                            className=" bg-gradient-to-r m-2 from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg text-white px-5 py-2.5 rounded-lg  duration-300  transform hover:-translate-y-0.5 flex items-center gap-2"
                                        >
                                            <FontAwesomeIcon
                                                icon={faSyncAlt}
                                                className="ml-2"
                                            />
                                            بازیابی مجدد
                                        </button>
                                    </div>
                                </div>
                                {/* Filters */}
                                <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
                                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                        {/* User Filter */}
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                کاربر
                                            </label>
                                            <div className="relative">
                                                <select
                                                    name="user"
                                                    value={filters.user}
                                                    onChange={
                                                        handleFilterChange
                                                    }
                                                    className="w-full  bg-white px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all appearance-none"
                                                >
                                                    <option value="none">
                                                        همه کاربران
                                                    </option>
                                                    {userDataGet.map((user) => (
                                                        <option
                                                            key={user.id}
                                                            value={user.id}
                                                        >
                                                            {user.full_name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <FontAwesomeIcon
                                                    icon={faChevronDown}
                                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                وضعیت
                                            </label>
                                            <div className="relative">
                                                <select
                                                    name="status"
                                                    value={filters.status}
                                                    onChange={
                                                        handleFilterChange
                                                    }
                                                    className="w-full  bg-white px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all appearance-none"
                                                >
                                                    <option value="none">
                                                        همه وضعیت‌ها
                                                    </option>
                                                    <option value="pending">
                                                        در انتظار
                                                    </option>
                                                    <option value="confirm">
                                                        تایید شده
                                                    </option>
                                                    <option value="reject">
                                                        رد شده
                                                    </option>
                                                </select>
                                                <FontAwesomeIcon
                                                    icon={faChevronDown}
                                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                از تاریخ
                                            </label>
                                            <div className="relative">
                                                <DatePicker
                                                    inputMode="none"
                                                    calendar={persian}
                                                    locale={persian_fa}
                                                    value={selectedDateStart}
                                                    onChange={
                                                        handleDateStartChange
                                                    }
                                                    plugins={[
                                                        <Toolbar
                                                            position="bottom"
                                                            sort={[
                                                                'close',
                                                                'today',
                                                                'deselect',
                                                            ]}
                                                        />,
                                                    ]}
                                                    format="YYYY/MM/DD"
                                                    className="w-full  bg-white  rounded-xl "
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        padding: '10px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #ccc',
                                                    }}
                                                />
                                                <FontAwesomeIcon
                                                    icon={faCalendarDays}
                                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                تا تاریخ
                                            </label>
                                            <div className="relative">
                                                <DatePicker
                                                    inputMode="none"
                                                    calendar={persian}
                                                    locale={persian_fa}
                                                    value={selectedDateEnd}
                                                    onChange={
                                                        handleDateEndChange
                                                    }
                                                    plugins={[
                                                        <Toolbar
                                                            position="bottom"
                                                            sort={[
                                                                'close',
                                                                'today',
                                                                'deselect',
                                                            ]}
                                                        />,
                                                    ]}
                                                    format="YYYY/MM/DD"
                                                    className="w-full  bg-white  rounded-xl "
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        padding: '10px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #ccc',
                                                    }}
                                                />
                                                <FontAwesomeIcon
                                                    icon={faCalendarDays}
                                                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Table Container - Force Desktop Layout */}
                                <div className="overflow-x-auto w-full">
                                    <div
                                        className="w-full"
                                        style={{ minWidth: '100%' }}
                                    >
                                        <table className="w-full divide-y divide-gray-200">
                                            {/* Table Header */}
                                            <thead className="bg-gray-50">
                                                <tr>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        <div className="flex items-center justify-center">
                                                            <span>
                                                                نام کاربر
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        <div className="flex items-center justify-center">
                                                            <span>
                                                                نوع مرخصی
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        <div className="flex items-center justify-center">
                                                            <span>
                                                                تاریخ مرخصی
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        <div className="flex items-center justify-center">
                                                            <span>
                                                                تاریخ ثبت
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        <div className="flex items-center justify-center">
                                                            <span>وضعیت</span>
                                                        </div>
                                                    </th>
                                                    <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                        مشاهده
                                                    </th>
                                                    {RequestQueue.getAuthResult()
                                                        ?.user?.role?.abilities
                                                        ?.furlough_all
                                                        ?.delete && (
                                                        <th className="px-6 py-4 text-center text-sm font-medium text-gray-600 uppercase tracking-wider">
                                                            حذف
                                                        </th>
                                                    )}
                                                </tr>
                                            </thead>

                                            {/* Table Body */}
                                            <tbody className="bg-white divide-y divide-gray-100">
                                                {dataGet.map((item) => (
                                                    <tr
                                                        key={item.id}
                                                        className="group transition-all duration-300 hover:bg-gradient-to-r hover:to-indigo-100 hover:via-white hover:from-purple-100 "
                                                    >
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            <div className="flex items-center justify-center">
                                                                <div className="flex-shrink-0 h-10 w-10 bg-indigo-100 rounded-full flex items-center justify-center mr-3">
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faUserClock
                                                                        }
                                                                        className="text-indigo-600"
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <div className="text-sm font-medium mr-2 text-gray-900">
                                                                        {
                                                                            item
                                                                                .user
                                                                                .full_name
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            <div>
                                                                <div className="text-sm font-medium text-gray-900">
                                                                    {item.type_furlough ===
                                                                    'daily'
                                                                        ? 'روزانه'
                                                                        : 'ساعتی'}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            <div>
                                                                <div className="text-sm font-medium text-gray-900">
                                                                    {item.type_furlough ===
                                                                    'hourly' ? (
                                                                        <>
                                                                            {FormJsonToShamsiDay(
                                                                                item.start_date
                                                                            )}
                                                                            <br />
                                                                            {`${FormJsonToShamsiTime(
                                                                                item.start_date
                                                                            )}
                                                                            
                                                                            
                                                                            تا ${FormJsonToShamsiTime(
                                                                                item.end_date
                                                                            )}
                                                                            `}
                                                                        </>
                                                                    ) : (
                                                                        FormJsonToShamsiDay(
                                                                            item.start_date
                                                                        )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            <div>
                                                                <div className="text-sm font-medium text-gray-900">
                                                                    {FormJsonToShamsiDay(
                                                                        item.created_at
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                                            <div>
                                                                <div className="text-sm font-medium text-gray-900">
                                                                    {getStatusBadge(
                                                                        item.status
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                                            <div className="flex justify-center space-x-3 space-x-reverse">
                                                                <button
                                                                    className="text-indigo-600 hover:text-indigo-800 bg-indigo-50 hover:bg-indigo-100 px-3 py-1.5 rounded-lg transition-colors duration-200"
                                                                    onClick={() => {
                                                                        navigate(
                                                                            `/furloughGetViewManagment/${item.id}`
                                                                        )
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        icon={
                                                                            faEdit
                                                                        }
                                                                        className="ml-2"
                                                                    />
                                                                    مشاهده
                                                                </button>
                                                            </div>
                                                        </td>
                                                        {RequestQueue.getAuthResult()
                                                            ?.user?.role
                                                            ?.abilities
                                                            ?.furlough_all
                                                            ?.delete && (
                                                            <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                                                <div className="flex justify-center space-x-3 space-x-reverse">
                                                                    <button
                                                                        onClick={() => {
                                                                            handlerDelete(
                                                                                item.id
                                                                            )
                                                                        }}
                                                                        className="text-red-600 hover:text-red-800 bg-red-50 hover:bg-red-100 px-3 py-1.5 rounded-lg transition-colors duration-200"
                                                                    >
                                                                        <FontAwesomeIcon
                                                                            icon={
                                                                                faEraser
                                                                            }
                                                                            className="ml-2"
                                                                        />
                                                                        حذف
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        )}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <Pagination
                                    current={currentPage}
                                    pageSize={pageSize}
                                    total={total}
                                    showLessItems={true}
                                    onChange={onChange}
                                    className="flex justify-center items-center"
                                    itemRender={renderPageItem}
                                />
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default FurloughGetManagment
